import validate from "/builds/1tool/kfv-portal-trainer/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/1tool/kfv-portal-trainer/middleware/auth.global.ts";
import manifest_45route_45rule from "/builds/1tool/kfv-portal-trainer/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}